import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { SearchableDashboard } from "../../../constants/searchableDashboards";
import { CedarShellSidenavContext } from "../../../components/Layouts/CedarShell/CedarShellSidenavContext";

interface Props {
  dashboard: SearchableDashboard;
}

// menuItems.ts (the old static MENU_ELEMENTS.archived.children list this component used to read)
// had these written as commented-out point_of_interest_summary values (never wired up to the old
// menu UI) - kept here as the card description since it's real existing copy rather than
// something invented. Keyed by `key` (dashboard.ts's own stable string identifier), not `id` (the
// numeric _dashboard.id) - a couple of dashboards never had a summary written, so those fall back
// to a generic line.
const ARCHIVED_DESCRIPTIONS: Record<string, string> = {
  mobility_report: "A tool to understand user mobility compared to a pre-pandemic baseline.",
  digital_customer_experience: "User experience scores and trends by market.",
  online_to_physical_insights: "Tracking the relationship between online behaviours and sales.",
  ariya_experience_monitor: "Real time data on Nissan's first global vehicle launch.",
  cxo_experiment_library: "A repository of over 80 data-led experiments that improve user experience.",
  mtm_metrics_that_matter: "Media investment impact metrics on future, in, and near market data.",
  midas: "Marketing investment performance and run rate data.",
  dmeo: "Digital marketing effectiveness and optimisation data.",
  clv: "Customer lifetime value modelling and insights.",
  search_interest: "Demand and traffic indicators: market level customer search behaviour data.",
  product_performance: "Product performance at a global and market level based on the user journey on the website.",
  ccs_cockpit: "Connected Car Services health and performance overview.",
  msrp: "Manufacturer's suggested retail price trends and comparisons by model.",
};
const DEFAULT_ARCHIVED_DESCRIPTION = "This dashboard is no longer actively maintained but is kept for reference.";

// Same reusable-card idea as DashboardCard, but archived dashboards have no category/KPI or
// favourite state, so this deliberately omits the pill and favourite button.
export const ArchivedDashboardCard = (props: Props) => {
  const { dashboard } = props;
  const history = useHistory();
  const { setCollapsed } = useContext(CedarShellSidenavContext);

  const handleOpen = () => {
    setCollapsed(true);
    history.push({ pathname: dashboard.path, search: "" });
  };

  return (
    <div className="archived_dashboard_card" data-test-id={`archived-dashboard-card-${dashboard.key}`}>
      <h3 className="archived_dashboard_card_name">{dashboard.name}</h3>
      <p className="archived_dashboard_card_description">{ARCHIVED_DESCRIPTIONS[dashboard.key] ?? DEFAULT_ARCHIVED_DESCRIPTION}</p>
      <button className="archived_dashboard_card_open" onClick={handleOpen} data-test-id={`archived-dashboard-card-open-${dashboard.key}`}>
        Open
      </button>
    </div>
  );
};
